<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="integral_center">
      <div class="top_box flex Flexjustify Flexalign"
        :style="{ backgroundImage: `url(${iconPath('integral_top_bg.png')})` }">
        <div class="content_top">
          <div class="month flex Flexalign">
            {{ month }}
            <div class="month_text mar_left_15">月</div>
          </div>
          <div class="month_box">
            <div class="flex Flexalign FlexBetween">
              <div class="flex Flexalign sign_total">
                您已连续签到
                <div class="sign_total_value">1</div>
                天
              </div>
              <div class="flex Flexalign">
                <el-select v-model="yearValue" placeholder="Select" size="large" style="width: 110px; height: 36px">
                  <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <el-select v-model="monthValue" placeholder="Select" size="large"
                  style="width: 110px; height: 36px; margin-left: 30px">
                  <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </div>
            </div>
            <div class="calendar_box">
              <div class="week_box flex FlexBetween">
                <div class="week_one">一</div>
                <div class="week_one">二</div>
                <div class="week_one">三</div>
                <div class="week_one">四</div>
                <div class="week_one">五</div>
                <div class="week_one">六</div>
                <div class="week_one">日</div>
                <div class="week_one">一</div>
                <div class="week_one">二</div>
                <div class="week_one">三</div>
                <div class="week_one">四</div>
                <div class="week_one">五</div>
                <div class="week_one">六</div>
                <div class="week_one">日</div>
              </div>
              <div class="flex FlexBetween FlexWrap days_box">
                <div v-for="(item, index) in daysList" :key="index" class="days_one"
                  :class="[item.isShow ? '' : 'visible']">
                  {{ item.days }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
export default {
  name: "GjkcH5Record",

  data() {
    return {
      month: 1,
      yearOptions: [],
      yearValue: 2024,
      monthOptions: [],
      monthValue: 10,
      daysList: [],
    };
  },

  mounted() {
    this.getMonthOptions();
    this.getYearOptions();
    this.getMonthdays();
  },

  methods: {
    getMonthOptions() {
      for (let i = 1; i < 13; i++) {
        this.monthOptions.push({ label: i + "月", value: i });
      }
    },
    getYearOptions() {
      for (let i = 2010; i < 2026; i++) {
        this.yearOptions.push({ label: i + "年", value: i });
      }
    },
    getMonthdays() {
      const month = this.$Moment(this.yearValue + "-" + this.monthValue);
      // 获取首日信息
      const firstDay = month.startOf("month");
      const firstWeek = firstDay.isoWeekday();
      // 获取末日信息
      //   const lastDay = month.endOf("month");
      //   const lastWeek = lastDay.isoWeekday();
      // 本月一共多少天
      const days = month.endOf("month").date();
      // 遍历本月天数显示
      for (let i = 1; i <= days; i++) {
        this.daysList.push({
          date: firstDay
            .startOf("month")
            .add(i - 1, "days")
            .format("YYYY-MM-DD"),
          days: i,
          isShow: true,
        });
      }
      // 前补齐
      for (let i = 1; i < firstWeek; i++) {
        this.daysList.unshift({
          date: firstDay.subtract(i, "days").format("YYYY-MM-DD"),
          days: 7 - i,
          isShow: false,
        });
      }
      // 后补齐
      for (let i = 1; i < 43 - firstWeek + 1 - days; i++) {
        this.daysList.push({
          date: firstDay.subtract(i, "days").format("YYYY-MM-DD"),
          days: 7 - i,
          isShow: false,
        });
      }
      console.log(this.daysList);
    },
  },
};
</script>

<style lang="scss" scoped>
.integral_center {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}

.top_box {
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  background-size: 100% 100%;

  .content_top {
    width: $pageMainWidth;
    position: relative;

    .month {
      font-weight: bold;
      font-size: 36px;
      color: #ffffff;
      margin-left: 40px;
      position: absolute;
      top: -60px;
    }

    .month_text {
      font-size: 20px;
      color: #ffffff;
    }

    .month_box {
      width: 100%;
      height: 356px;
      background: #ffffff;
      border-radius: 10px;
      position: absolute;
      top: 30px;
      padding: 20px;
      box-sizing: border-box;

      .sign_total {
        font-size: 18px;
        color: #c3813b;

        .sign_total_value {
          font-size: 28px;
          color: #c3813b;
          font-weight: 600;
          margin: 0 10px;
        }
      }

      .calendar_box {
        padding: 15px;
        margin-top: 20px;
        box-sizing: border-box;

        .week_box {
          font-weight: bold;
          font-size: 20px;
          color: #c3813b;
          width: 100%;

          .week_one {
            width: calc(100% / 14);
            text-align: center;
          }
        }

        .visible {
          opacity: 0;
        }

        .days_box {
          width: 100%;
        }

        .days_one {
          font-size: 20px;
          color: #c3813b;
          width: calc(100% / 14);
          text-align: center;
          margin-top: 40px;
        }
      }
    }
  }
}

:deep(.el-select__wrapper.is-focused) {
  box-shadow: none;
}

:deep(.el-select__wrapper) {
  box-shadow: none;
  border: 1px solid #c3813b;
}

:deep(.el-select__placeholder) {
  font-size: 18px;
  color: #c3813b;
}

:deep(.el-select__caret) {
  font-size: 18px;
  color: #c3813b;
}
</style>